import moment from 'moment';
export var MIN_DURATION_MINUTES = 15;
/**
 * Ensures startTime and endTime are in order and at least MIN_DURATION_MINUTES
 * apart. The field that was just edited wins — the opposite field is pushed to
 * maintain the gap:
 *   - startTime changed → endTime pushed to startTime + 15 min
 *   - endTime changed   → startTime pulled to endTime - 15 min
 */
export function enforceTimeConstraints(_a) {
    var changedField = _a.changedField, startTime = _a.startTime, endTime = _a.endTime;
    var diffMinutes = endTime.diff(startTime, 'minutes');
    if (diffMinutes >= MIN_DURATION_MINUTES) {
        return { startTime: startTime, endTime: endTime };
    }
    if (changedField === 'startTime') {
        return {
            startTime: startTime,
            endTime: startTime.clone().add(MIN_DURATION_MINUTES, 'minutes'),
        };
    }
    return {
        startTime: endTime.clone().subtract(MIN_DURATION_MINUTES, 'minutes'),
        endTime: endTime,
    };
}
export function isStartAndEndTimeValid(startTime, endTime, now, disallowPastStart) {
    if (now === void 0) { now = moment(); }
    if (disallowPastStart === void 0) { disallowPastStart = false; }
    var startIsValid = !startTime.isAfter(endTime) &&
        (!disallowPastStart || !startTime.isBefore(now, 'minute'));
    return startIsValid && !endTime.isBefore(now);
}
export function rruleEndsBeforeStart(rrule, dateStart) {
    if (!rrule || !dateStart)
        return false;
    var until = rrule.options.until;
    if (!until)
        return false;
    return moment(until).isBefore(dateStart);
}
